import Walker from "../../../views/Walker";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import WalkerDetails from "../../../views/WalkerDetails";

const WalkerRoutes = [
  {
    menuName: MenuNames.WALKER,
    path: "/Walker",
    component: Walker,
    exact: true,
  },
  {
    menuName: MenuNames.WALKER,
    path: "/walker-details",
    component: WalkerDetails,
    exact: true,
  },
];

export default WalkerRoutes;
